import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider, Spin } from 'antd';
import Lottie from 'lottie-react';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { convertHexToRgb } from '../../utils/color';
import LoadingSpinnerLottie from './LoadingSpinner.lottie';
import { SpinnerContainer } from './LoadingSpinner.style';
export function LoadingSpinner({ backgroundColor, color, size, variant = 'default', }) {
    const theme = useTheme();
    const targetColor = color !== null && color !== void 0 ? color : theme.Color.Brand.Primary;
    const fontFamily = theme.Typography.FontFamily;
    const convertedSize = useMemo(() => {
        switch (size) {
            case 'XXSmall':
            case 'XSmall':
            case 'Small':
                return 'small';
            case 'Large':
            case 'XLarge':
            case 'XXLarge':
                return 'large';
            case 'Medium':
            default:
                return 'default';
        }
    }, [size]);
    const convertedColor = useMemo(() => {
        const color = convertHexToRgb(targetColor);
        if (!color)
            return undefined;
        const [red, green, blue] = color;
        return [red / 255, green / 255, blue / 255];
    }, [targetColor]);
    if (!convertedColor)
        return null;
    return (_jsx(ConfigProvider, { theme: {
            token: {
                colorPrimary: targetColor,
                fontFamily,
            },
        }, children: variant === 'dots' ? (_jsx(Spin, { size: convertedSize })) : (_jsx(SpinnerContainer, { size: size, children: _jsx(Lottie, { animationData: LoadingSpinnerLottie(convertedColor), loop: true, style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                } }) })) }));
}
//# sourceMappingURL=LoadingSpinner.js.map